'use client';

import { useScrollPosition } from '@/shared/hooks/use-scroll-position';

export const ScrollRestore = ({ pagePath = '' }: { pagePath?: string }) => {
	useScrollPosition({ pagePath });
	return null;
};
